var swiperArray = [];
jQuery(document).ready(function($) {

    $('.swiper-wrapper').each(function(index){
        $(this).children().each(function(){
            $(this).addClass('swiper-slide');
        });
        var origin = $(this).parent();
        var section = origin.closest('.shopify-section');
        section.addClass('slideshow-' + index);
        if (origin.hasClass('slideshow--home')){
            var config = {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: '.slideshow-' + index + ' .slideshow__navigation-next',
                    prevEl: '.slideshow-' + index + ' .slideshow__navigation-prev',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 48
                    }
                }
            }
            swiperArray.push(new Swiper('.slideshow-' + index + ' .slideshow', config));
        }
        else if (origin.hasClass('slideshow--pdpThumbs')){
            var config = {
                slidesPerView: 4,
                spaceBetween: 10,
                loop: false,
                direction: 'horizontal',
                breakpoints: {
                    1000: {
                        direction: 'vertical'
                    }
                }
            }
            swiperArray.push(new Swiper('.slideshow-' + index + ' .slideshow--pdpThumbs', config));
        }
        else if (origin.hasClass('slideshow--pdpMain')){
            var config = {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                thumbs: {
                    swiper: '.slideshow-' + index + ' .slideshow--pdpThumbs'
                }
            }
            swiperArray.push(new Swiper('.slideshow-' + index + ' .slideshow--pdpMain', config));
        }
        else if (origin.hasClass('collectionProducts__sliderWrapper')){
            var config = {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                breakpoints: {
                    1000: {
                        slidesPerView: 4
                    }
                }
            }
            swiperArray.push(new Swiper('.slideshow-' + index + ' .collectionProducts__sliderWrapper', config));
        }
        else{
            console.log('make sure your slideshow is set up correctly');
        }
    });
    console.log(swiperArray);
})
